import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import './style.scss';


export default ToastContainer;